let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("fliVL"), load("dWC9u")]).then(() => parcelRequire('e9FEZ'));